import React from "react";
import "./Skill.scss";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { TUserSectionProp } from "@utils/Interfaces";
import { Empty, Skeleton } from "antd";

const Skill: React.FC<TUserSectionProp> = ({
  setIsEditProfileVisible,
  setActiveTab,
  userProfile,
  loading,
}) => {

  return (
    <div className="card card-profile skill">
      <div
        className="edit-action"
        onClick={() => {
          setIsEditProfileVisible(true);
          setActiveTab("4");
        }}
      >
        <EditOutlined />
      </div>
      <div className="card-title">Skills</div>
      <div
        className={`skill-group ${
          userProfile.skills?.length == 0 || userProfile.skills == null
            ? "justify-content-center"
            : ""
        }`}
      >
        {!loading ? (
          <Skeleton active />
        ) : userProfile.skills?.length == 0 || userProfile.skills == null ? (
          <Empty className="" />
        ) : (
          userProfile.skills.map((item: any, index) => {
            return (
              <div className="skill-item" key={index}>
                <span>{item}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Skill;
